<template>
  <tw-navbar :items="menuItems" :items-left="menuItemsLeft" :user="currentUser">
    <template #left>
      <div v-if="!currentUser" class="grid-cols-2 gap-2 hidden md:grid">
        <tw-button variant="info" :to="{ name: 'Login' }">
          Login
        </tw-button>
        <tw-button v-if="!currentUser" variant="primary" @click="$refs.organizationRegisterModal.open()">
          Create Your Fundraiser
        </tw-button>
      </div>
      <organization-register-integrated-modal ref="organizationRegisterModal" />
    </template>
  </tw-navbar>
</template>

<script>
import { mapActions, mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import TwNavbar from '@/components/generic/navbar/tw-navbar.vue'
import TwButton from '@/components/generic/tw-button.vue'
import OrganizationRegisterIntegratedModal from './organizations/organization-register-integrated-modal.vue'

export default {
  name: "TopNavigation",
  components: { OrganizationRegisterIntegratedModal, TwButton, TwNavbar },
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return useAuthStore().user
    },
    menuItems() {
      if(this.currentUser) {
        return [
          { label: 'Home', icon: 'pi pi-fw pi-home', to: { name: 'Home' } },
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: { name: 'DashboardPage' } },
          { label: 'Reports', icon: 'pi pi-fw pi-chart-line', to: { name: 'ReportsPage' } },
          { label: 'Fundraisers', icon: 'pi pi-fw pi-home', to: { name: this.currentUser.has_organization? 'FundraisersIndexPage':'MyFundraiserPagesIndexPage' } },
          ...(this.currentUser.has_organization)? [{ label: 'Organizations', icon: 'pi pi-fw pi-home', to: { name: 'OrganizationsIndexPage' } }]:[],
        ]
      }
      else {
        return [
          { label: '100% Free to use', icon: 'pi pi-fw pi-home', to: { name: 'StaticFreeToUsePage' } },
          { label: 'How it works', icon: 'pi pi-fw pi-home', to: { name: 'StaticHowItWorksPage' } },
          { label: 'For Organizations', icon: 'pi pi-fw pi-home', to: { name: 'StaticForOrganizationsPage' } },
          { label: 'Contact', icon: 'pi pi-fw pi-home', to: { name: 'ContactPage' } },
        ]
      }
    },
    menuItemsLeft() {
      if(this.currentUser) {
        return [
          { label: this.currentUser.name, icon: 'pi pi-fw pi-user', to:{ name: 'User', params: { userId: this.currentUser.id }  }},
          ...(this.currentUser.admin ? [{ label: 'Platform', icon: 'pi pi-fw pi-cog', to: { name: 'PlatformDashboardPage' } }] : []),
          { label: 'Help', icon: 'pi pi-fw pi-question-mark-circle', to:{ name: 'User', params: { userId: this.currentUser.id }  }},
          { label: 'Profile', icon: 'pi pi-fw pi-user', to:{ name: 'User', params: { userId: this.currentUser.id }  }},
          { label: 'Logout', icon: 'pi pi-fw pi-sign-out', command: this.logoutUser}
        ]
      }
      else {
        return [
          { label: 'Login', icon: 'pi pi-fw pi-sign-in', to: { name: 'Login' }},
          { label: 'Register', icon: 'pi pi-fw pi-user-plus', to: { name: 'Register' }}
        ]
      }
    }
  },
  async mounted() {
    try {
      if(!this.currentUser) {
        // await this.attempt_user()
      }
    } catch (e) {
      // console.error(e)
    }
  },
  methods: {
    leftMenuToggle($event) {
      this.$refs.menu.toggle($event)
    },
    ...mapActions(useAuthStore, ['logout','attempt_user']),
    logoutUser() {
      this.logout()
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
    },
  },
}
</script>
